import { UPDATE_AI_CONFIG, LOAD_AI_CONFIG, UPDATE_CHAPTER_AI_CONFIG, DELETE_CHAPTER_FILE, ADD_CHAPTER_FILE } from "../types";

const initialState = {
    config: {},
};

export const configAIReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_AI_CONFIG:
            return {
                ...state,
                config: action.payload ?? initialState.config,
            };

        case UPDATE_AI_CONFIG:
            return {
                ...state,
                config: {
                    ...state.config,
                    ...action.payload,
                },
            };

        case UPDATE_CHAPTER_AI_CONFIG: {
            const { chapterId, config } = action.payload;
            const oldAiMap = state.config.aiMap || [];

            let found = false;
            const updatedAiMap = oldAiMap.map((item) => {
                if (item.chapterId === chapterId) {
                    found = true;
                    return { ...item, ...config };
                }
                return item;
            });

            if (!found) {
                updatedAiMap.push({ chapterId, ...config });
            }

            return {
                ...state,
                config: {
                    ...state.config,
                    aiMap: updatedAiMap,
                },
            };
        }
        case DELETE_CHAPTER_FILE: {
            const { chapterId, filename } = action.payload;
            const aiMap = state.config.aiMap || [];

            const updatedAiMap = aiMap.map(item =>
                item.chapterId === chapterId
                    ? {
                        ...item,
                        uploadedFiles: (item.uploadedFiles || []).filter(
                            f => f.filename !== filename
                        ),
                    }
                    : item
            );

            return { ...state, config: { ...state.config, aiMap: updatedAiMap } };
        }
        case ADD_CHAPTER_FILE: {
            const { chapterId, file } = action.payload;
            const aiMap = state.config.aiMap || [];

            const updatedAiMap = aiMap.map(item =>
                item.chapterId === chapterId
                    ? {
                        ...item,
                        uploadedFiles: [...(item.uploadedFiles || []), file],
                    }
                    : item
            );

            return { ...state, config: { ...state.config, aiMap: updatedAiMap } };
        }

        default:
            return state;
    }
};
